import './media/module';
import './guestlists/module';
import './bo/bo-module';
import './action_log/module';
import './documents/module';
import './pos/pos-module';
import './tickets/module';
import './contacts/module';
import './core/module';
import './exports/module';
import './templates/module';
import './rsvps/module';
import './wallets/module';
import './merge-tags/module';
import './messages/module';
import './users/module';
import './navigation/module';

angular.module('festzelt-os.modules', [
    'festzelt-os.components',
    'festzelt-os.modules.action_log',
    'festzelt-os.modules.merge-tags',
    'festzelt-os.modules.bo',
    'festzelt-os.modules.contacts',
    'festzelt-os.modules.core',
    'festzelt-os.modules.documents',
    'festzelt-os.modules.guestlists',
    'festzelt-os.modules.media',
    'festzelt-os.modules.pos',
    'festzelt-os.modules.templates',
    'festzelt-os.modules.tickets',
    'festzelt-os.modules.exports',
    'festzelt-os.modules.rsvps',
    'festzelt-os.modules.wallets',
    'festzelt-os.modules.messages',
    'festzelt-os.modules.users',
    'festzelt-os.modules.navigation'
]);



// WEBPACK FOOTER //
// ./src/app/modules/module.js